import {Component, Input, OnInit, ViewChildren} from '@angular/core';
import {Storyboard} from 'storyboard-renderer';
import {StoryboardService} from '../../shared/storyboard.service';
import {Router} from '@angular/router';
import {TemplateService} from "../../../template/shared/template.service";
import {PromptModalComponent} from "../../../shared/prompt-modal/prompt-modal.component";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-storyboard-edit-header',
  templateUrl: './storyboard-edit-header.component.html',
  styleUrls: ['./storyboard-edit-header.component.scss']
})
export class StoryboardEditHeaderComponent implements OnInit {

  @Input() storyboard;
  storyboardSaving = false;
  titleSaving = false;
  publishing = false;
  editing = false;
  tmpTitle: string;
  autoSave = false;
  autoSaveInterval = null;
  autoSaveTime = 60000; // 60 second

  @ViewChildren('input') vc;

  service;

  constructor(private modalService: NgbModal, private storyboardService: StoryboardService,
              private router: Router, private templateService: TemplateService) {
  }

  ngOnInit() {
    this.service = this.storyboard.constructor.name === Storyboard.name ? this.storyboardService : this.templateService;
    //this.enableAutoSave();
  }

  toggleAutoSave(event) {
   this.autoSave ? this.disableAutoSave() : this.enableAutoSave();
  }

  disableAutoSave() {
    this.autoSave = false;
    clearInterval(this.autoSaveInterval);
  }

  enableAutoSave() {
    this.autoSave = true;
    clearInterval(this.autoSaveInterval);

    this.autoSaveInterval = setInterval(() => {
      this.save();
    }, this.autoSaveTime);
  }

  swapEditMode() {
    this.editing = !this.editing;
    this.tmpTitle = this.storyboard.title;

    if (this.editing) {
      const self = this;
      setTimeout(function() {
        self.vc.first.nativeElement.focus();
      }, 500);
    }

  }

  saveTitle() {

    if (!this.tmpTitle) {
      return;
    }

    this.titleSaving = true;

    this.storyboard.title = this.tmpTitle;

    this.service.updateTitle(this.storyboard.id, this.storyboard.title).then(() => {
      this.swapEditMode();
      this.titleSaving = false;
    }, () => {
      this.titleSaving = false;
    });
  }

  save(): Promise<any> {

    this.storyboardSaving = true;

    return this.service.update(this.storyboard).then(storyboard => {
      this.storyboardSaving = false;
    }, () => {
      this.storyboardSaving = false;
    });
  }

  publish(): Promise<any> {

    const modalRef = this.modalService.open(PromptModalComponent);
    modalRef.componentInstance.body = 'Are you sure you want to save and publish the storyboard?';
    return modalRef.result.then((result) => {
      /**
       * make sure to save before publishing
       */
      this.save().then(() => {

        this.publishing = true;
        this.storyboardService.publish(this.storyboard.id, {userId: this.storyboard.user.id}).then(() => {
          this.publishing = false;
          this.router.navigate(['/storyboard-publish', this.storyboard.id]);
        }, () => {
          this.publishing = false;
        });

      });


    });
  }

  isAllowedToPublishVideo() {
    return this.storyboard.constructor.name === Storyboard.name;
  }

  isAllowedToSaveVideo() {
    return this.storyboard.constructor.name === Storyboard.name;
  }

  backToList() {
    const storyboard = 'storyboard';
    const template = 'template';
    const currentUrl = this.router.url;
    if (currentUrl.indexOf(storyboard) != -1) {
      this.router.navigate(['/']);
    } else if (currentUrl.indexOf(template) != -1) {
      this.router.navigate(['/templates']);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/storyboard/storyboard-edit/storyboard-edit-header/storyboard-edit-header.component.ts